import { Fragment, useState } from 'react'
import { Dialog, Transition } from '@headlessui/react'
import { FormattedMessage } from 'react-intl';

const ForgotPasswordModal = (props) => {
  const {isOpen, toggleModal} = props;

  const [email, setEmail] = useState('');
  const [emailValid, setEmailValid] = useState(false);
  const [responseMsg, setResponseMsg] = useState('');
  const [loading, setLoading] = useState(false);

  // Simple email regex validator
  const validateEmail = (value) => {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);
  };

  const handleEmailChange = (e) => {
    const value = e.target.value;
    setEmail(value);
    setEmailValid(validateEmail(value));
    setResponseMsg('');
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!emailValid) return;
    setLoading(true);
    setResponseMsg('');
    try {
      const res = await fetch(`/reset_password_email.php?email=${encodeURIComponent(email)}&email=${encodeURIComponent(email)}`, {
        method: 'GET',
        headers: {
          'Accept': 'application/json'
        }
      });
      const data = await res.json();
      setResponseMsg(data.message || (<FormattedMessage id="forgot_password.check_email" defaultMessage="Check your email for further instructions." />));
    } catch (err) {
      setResponseMsg(<FormattedMessage id="forgot_password.error" defaultMessage="There was an error resetting your password." />);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Transition.Root show={isOpen ? true : false} as={Fragment}>
        <Dialog as="div" className="relative z-10" onClose={toggleModal}>
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
          </Transition.Child>

          <div className="fixed inset-0 z-10 overflow-y-auto">
            <div className="flex justify-center p-4 text-center sm:items-start sm:p-0">
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                enterTo="opacity-100 translate-y-0 sm:scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              >
                <Dialog.Panel className="relative transform overflow-hidden rounded-lg bg-white px-4 pt-5 pb-4 text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-lg sm:p-6">
                  <p>
                    <FormattedMessage id="forgot_password.p1" defaultMessage="Please enter your e-mail address and a new password will be sent to that address shortly." />
                  </p>
                  <p className="my-4">
                    <FormattedMessage id="forgot_password.p2" defaultMessage="IMPORTANT - After receiving the new password, please clear your browser cache and close and reopen your browser before using the new password. As a security precaution, please change the password after successfully logging in." />
                  </p>
                  <form className="space-y-6" action="#" method="POST" onSubmit={handleSubmit}>
                    <div className='my-2'>
                      <label htmlFor="email" className="block text-sm font-medium text-gray-700">
                      E-mail
                      </label>
                      <div className="mt-1">
                        <input
                          id="email"
                          name="email"
                          type="text"
                          autoComplete="email"
                          required
                          value={email}
                          onChange={handleEmailChange}
                          className="block w-full appearance-none rounded-md border border-gray-300 px-3 py-2 placeholder-gray-400 shadow-sm focus:border-blue-500 focus:outline-none focus:ring-blue-500 sm:text-sm"
                        />
                        {!emailValid && email.length > 0 && (
                          <p className="mt-1 text-xs text-red-600">
                            <FormattedMessage id="forgot_password.invalid_email" defaultMessage="Please enter a valid email address." />
                          </p>
                        )}
                      </div>
                    </div>

                    <div>
                      <button
                        type="submit"
                        className="flex w-full justify-center rounded-md border border-transparent bg-[#1A658F] px-4 py-2 text-base font-medium text-white shadow-sm hover:bg-cyan-600 focus:outline-none focus:ring-2 focus:ring-cyan-600 focus:ring-offset-2 sm:mt-0 sm:w-auto sm:text-sm disabled:opacity-50"
                        disabled={!emailValid || loading}
                      >
                        {loading ? 'Submitting...' : 'Submit'}
                      </button>
                    </div>
                    {responseMsg && (
                      <div className="response positive mt-2 text-center text-sm text-rose-700">{responseMsg}</div>
                    )}
                  </form>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
    </Transition.Root>
  )
};

export default ForgotPasswordModal;